<fuse-drawer
  class="w-screen min-w-screen sm:w-100 sm:min-w-100 z-999"
  fixed
  [mode]="'over'"
  [name]="'onlineHelpDrawer'"
  [position]="'right'"
  #drawer
>
  <div class="flex flex-auto w-full h-full">
    <div class="flex flex-col flex-auto pt-6 px-4 sm:p-6 sm:pt-6 overflow-y-auto h-full" #scrollContainer>
      <!-- Header with title and navigation controls -->
      <div class="flex items-center justify-between">
        <span class="text-lg font-medium truncate">{{ (activeDocument$ | async)?.title }}</span>
        <div class="flex items-center gap-1">
          <button mat-icon-button (click)="goBack()" [disabled]="!canGoBack()" matTooltip="Back">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
          </button>
          <button mat-icon-button (click)="goForward()" [disabled]="!canGoForward()" matTooltip="Forward">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:arrow-right'"></mat-icon>
          </button>
          <button mat-icon-button (click)="close()" matTooltip="Close">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
          </button>
        </div>
      </div>

      <mat-divider class="mt-4 mb-6"></mat-divider>

      <!-- Rendered markdown content -->
      <div
        class="prose prose-sm dark:prose-invert max-w-none prose-code:rounded-sm prose-code:px-1 prose-code:bg-gray-800 prose-a:text-primary"
        [innerHTML]="$safeNavigationMigration((activeDocument$ | async)?.htmlContent)"
        (click)="innerHtmlClicked($event)"
      ></div>
    </div>
  </div>
</fuse-drawer>
